import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';

const steps = ["Flight Details", "Select Seats", "Payment"];

export default class HorizontalLinearStepper extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        activeStep: 0,
        skipped: new Set()
    }
    render() {
        const { skipped, activeStep } = this.state

        const isStepOptional = (step) => {
            return step === 1;
        };

        const isStepSkipped = (step) => {
            return skipped.has(step);
        };

        const handleNext = () => {
            console.log("handling next ")
            let newSkipped = skipped;
            if (isStepSkipped(activeStep)) {
                newSkipped = new Set(newSkipped.values());
                newSkipped.delete(activeStep);
            }
            this.setState({
                activeStep: this.state.activeStep + 1,
                skipped: newSkipped
            }, () => console.log(this.state.activeStep))

        };

        const handleBack = () => {
            this.setState({
                activeStep: this.state.activeStep - 1,

            })

        };

        const handleSkip = () => {
            if (!isStepOptional(activeStep)) {
                // You probably want to guard against something like this,
                // it should never occur unless someone's actively trying to break something.
                throw new Error("You can't skip a step that isn't optional.");
            }
            const newSkipped = new Set(skipped.values());
            newSkipped.add(activeStep);
            this.setState({
                activeStep: this.state.activeStep + 1,
                skipped: newSkipped
            })


        };

        const handleReset = () => {
            this.setState({
                activeStep: 0

            })
        };

        return (
            <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        if (isStepOptional(index)) {
                            labelProps.optional = (
                                <Typography variant="caption">Optional</Typography>
                            );
                        }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false;
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>

                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleReset}>Reset</Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>
                        {activeStep == 0 ? 
                        <div style = {{height : '55vh' , backgroundColor : 'blue'}}>
                           {/* your div of choice here  */}


                            <h1>flight details </h1>


                        </div> :
                        activeStep == 1 ? 
                        <div style = {{height : '55vh' , backgroundColor : 'darkgreen'}}>
                           {/* your div of choice here  */}

                            <h1>seats </h1>



                        </div> :
                        <div style = {{height : '55vh' , backgroundColor : 'darkblue'}}>
                           {/* your div of choice here  */}

                            <h1>payment </h1>



                        </div>
                        }
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Back 
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            { 
                                
                                /* isStepOptional(activeStep) && (
                                <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                    Skip
                                </Button>
                            )           */ 
                            
                            }

                            <Button onClick={handleNext}>
                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                            </Button>
                        </Box>
                    </React.Fragment>
                )}
            </Box>
        );
    }
}